import { gql } from 'apollo-angular';

const GET_OFFER = gql`
  query getOffer($id: Long!) {
    offer(id: $id) {
      id
      name
      status
      unorderedTiers
      unorderedPricing
      currentTier {
        id
        name
      }
      supportedOfferTerm {
        commitmentType
        possiblePricingType
        possibleDurationsInMonths
      }
      isValidForSubmission
      productStats {
        isValidForSubmission
        productPricingStatus
      }
      term {
        isValidForSubmission
      }
      offerTiers {
        isValidForSubmission
        tiers {
          id
          name
          description
          tierType
          order
          unitMarketShare
          tierOrderDisplay
          dollarMarketShare
          spendLevelType
          absoluteDollars
          absoluteUnits
        }
      }
      products {
        isIncumbentProduct
        product {
          catalogNumber
          description
          status
          packageString
          category {
            id
            name
          }
          subCategory {
            id
            name
          }
          statistics {
            crossReferenceStatistic {
              crossCount
            }
          }
          spend {
            lastPricePaid
          }
          productPackages {
            unitsInPackage
            uom
          }
          baseUom
        }
        productId
        formularyPrice
        prices {
          tierId
          packagePrice
          providedPackagePrice
        }
        pricingPackage {
          unitsInPackage
          uom
        }
      }
    }
  }
`;

export default GET_OFFER;
